import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/license/addOns/license.addOns.query.gql"
import type {
  LicenseAddOnsQuery,
  LicenseAddOnsQueryVariables,
} from "@/v2-backoffice-client/license/addOns/__types__/license.addOns.query"

type Options = QueryHookOptions<LicenseAddOnsQuery, LicenseAddOnsQueryVariables>

export function useLicenseAddOnsQuery(options?: Options) {
  return useQuery<LicenseAddOnsQuery, LicenseAddOnsQueryVariables>(
    query,
    options,
  )
}
